/*** IMPORTS FROM imports-loader ***/
var global = window;

module.exports = function surround(str, wrapper) {
  return [wrapper, str, wrapper].join('');
};

